import { FormEvent } from 'react';

const MAX_SECRET_LENGTH = 10000;

interface GenerateSecretScreenProps {
  secretText: string;
  saveError: string;
  isSaving: boolean;
  onSecretTextChange: (value: string) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
}

export function GenerateSecretScreen({
  secretText,
  saveError,
  isSaving,
  onSecretTextChange,
  onSubmit,
}: GenerateSecretScreenProps) {
  return (
    <form onSubmit={onSubmit}>
      <h1>Share a Secret</h1>
      <p className="subtitle">
        Enter your secret. You'll get a one-time link to share with the recipient.
      </p>

      <label htmlFor="secretText">Secret</label>
      <textarea
        id="secretText"
        value={secretText}
        onChange={(event) => onSecretTextChange(event.target.value)}
        placeholder="Type your secret here…"
        maxLength={MAX_SECRET_LENGTH}
      />

      <button className="btn btn-primary" type="submit" disabled={isSaving}>
        {isSaving ? 'Saving…' : 'Generate Link'}
      </button>

      {saveError ? <p className="error">{saveError}</p> : null}
    </form>
  );
}
